<div class="container p-3">
  <div class="d-flex flex-column">
    <div *ngIf="data.evaluator.displayRole == 'BCPO Access'">
      <mat-form-field appearance="outline">
        <mat-label>Choose Notification Type</mat-label>
        <mat-select [(ngModel)]="returnType">
          <mat-option value="1"> Secure Court Clearance </mat-option>
          <mat-option value="2"> Profile Information Update </mat-option>
          <mat-option value="3"> Mismatch Documents </mat-option>
          <mat-option value="4"> Others </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="returnType == '1'">
      <mat-form-field appearance="outline">
        <mat-label>Choose</mat-label>
        <mat-select [(ngModel)]="courtClearanceType">
          <mat-option value="1"> Dismissed </mat-option>
          <mat-option value="2"> On Probation</mat-option>
          <mat-option value="3"> Acquited </mat-option>
          <mat-option value="4"> Convicted </mat-option>
          <mat-option value="5"> Served </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- <ngx-dropzone
      (change)="onSelect($event)"
      [multiple]="false"
      accept="image/*,application/pdf"
      class="mt-3"
    >
      <ngx-dropzone-label
        >Click here to upload supporting files (optional)!
      </ngx-dropzone-label>
      <ngx-dropzone-preview
        *ngFor="let f of files"
        [removable]="true"
        (removed)="onRemove(f)"
      >
        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
      </ngx-dropzone-preview>
    </ngx-dropzone> -->
    <mat-form-field appearance="outline" class="mt-3">
      <mat-label>Remarks</mat-label>
      <textarea matInput [formControl]="remarks" rows="6"></textarea>
    </mat-form-field>

    <div class="d-flex justify-content-between mt-3">
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button
        mat-raised-button
        color="primary"
        style="color: white"
        (click)="handleSubmit()"
        [disabled]="isLoading"
      >
        {{ isLoading == true ? "Submitting" : "Submit" }}
      </button>
    </div>
  </div>
</div>
